// extracted by mini-css-extract-plugin
module.exports = {"PanelFooter":"nm_a pz_b pz_qn pz_ns pz_nt pz_rg"};